export default __webpack_public_path__ + "static/media/loading-ball.9fea6fc1.svg";